/**
 * Auth + API configuration. The committed defaults are the DEV Entra
 * registrations (jedi-dev-spa / jedi-dev-api) — client ids, tenant ids and
 * scopes are public identifiers by design (they ship in this bundle to every
 * browser); the no-committed-credentials rule governs credential positions,
 * not identifier positions. Production builds override via VITE_* variables
 * with the prod registration pair when it exists.
 */
export const authConfig = {
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID ?? '7c361779-00e9-4d71-8867-9bd8584a5bf5',
  authority:
    import.meta.env.VITE_AUTH_AUTHORITY ??
    'https://login.microsoftonline.com/0e2b1207-b020-4733-b2db-e22fd81a26c0',
  apiScope:
    import.meta.env.VITE_AUTH_API_SCOPE ??
    'api://8719986c-a0c8-41b0-8d7e-3dd480023d49/access_as_user',
  apiBaseUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:5088',
  // The people picker's directory search (ADR-0045): Microsoft Graph, delegated,
  // basic profiles only. The same in every environment; what differs per
  // environment is whether an administrator has granted it to that SPA.
  directoryScope: 'https://graph.microsoft.com/User.ReadBasic.All',
  directoryUrl: 'https://graph.microsoft.com/v1.0',
}
